exports.list = {
    path: '/kategori',
    name: 'kategori_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/kategori/List.vue"),
}
exports.show = {
    path: '/kategori/show/:id',
    name: 'kategori_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/kategori/Show.vue"),
}